import {
  CanDeleteOrganizationContractPermissions,
  CanEditOrganizationContractPermissions,
} from '../../../../../config/accessPolicies/accessPolicies';

export const canViewActionColumn: string[] = [
  ...CanEditOrganizationContractPermissions,
  ...CanDeleteOrganizationContractPermissions,
];
